function get(name: string) {
  return localStorage.getItem(name);  
}

function set(name: string, value: string) {
  localStorage.setItem(name, value);
}

export {
  get,
  set
}